import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
  type SupportedLanguage,
} from 'constants/language';

import LanguageSwitcher from './LanguageSwitcher';

const LanguageSwitcherContainer = ({ className }: { className?: string }) => {
  const { i18n } = useTranslation();

  const activeLanguage = normalizeLanguage(i18n.language);

  const handleLanguageChange = useCallback(
    (language: SupportedLanguage) => {
      void i18n.changeLanguage(language);
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    },
    [i18n],
  );

  return (
    <LanguageSwitcher
      className={className}
      activeLanguage={activeLanguage}
      onLanguageChange={handleLanguageChange}
    />
  );
};

export default React.memo(LanguageSwitcherContainer) as any;
